import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Result, Guard, UniqueEntityID } from '@digibricks/core';
export var CreatedFormRelease = /*#__PURE__*/function (_Entity) {
  _inherits(CreatedFormRelease, _Entity);

  var _super = _createSuper(CreatedFormRelease);

  function CreatedFormRelease() {
    _classCallCheck(this, CreatedFormRelease);

    return _super.apply(this, arguments);
  }

  _createClass(CreatedFormRelease, [{
    key: "version",
    get: function get() {
      return this.props.version;
    }
  }, {
    key: "publishedVersion",
    get: function get() {
      var _this$props$published;

      return (_this$props$published = this.props.publishedVersion) !== null && _this$props$published !== void 0 ? _this$props$published : null;
    }
  }, {
    key: "totalScore",
    get: function get() {
      return this.props.totalScore;
    }
  }, {
    key: "totalQuestions",
    get: function get() {
      return this.props.totalQuestions;
    }
  }], [{
    key: "create",
    value: function create(props, id) {
      var guardCollections = [{
        argument: props.version,
        argumentName: 'Version'
      }, {
        argument: props.totalQuestions,
        argumentName: 'Total Questions'
      }, {
        argument: props.totalScore,
        argumentName: 'Total Score'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      var createdFormRelease = new CreatedFormRelease(props, new UniqueEntityID(id));
      createdFormRelease.updatedAt = props.updatedAt;
      return Result.ok(createdFormRelease);
    }
  }]);

  return CreatedFormRelease;
}(Entity);